import $ from 'jquery';
import {cashbackOrderSpend, cashbackOrderSave, cashbackOrderCancel} from "../queries";
import {updatePrices} from "../utilities";
$(document).ready(function() {
    const toggle = $('.page-order-checkout-toggle');
    const icon = toggle.find('.page-order-checkout-toggle__icon');
    const form = $('.js-spend-cashback');
    const cashbackValue = form.find('input[name=order-bonus]');
    const cashbackRemove = $('.page-order-checkout__cashback--remove')
    toggle.find('.page-order-checkout-toggle__control').on('change', function() {
        if ($(this).is(':checked')) {
            icon.addClass('loading');
            setTimeout(async () => {
                const response = await cashbackOrderSpend();
                if (response.isSuccess){
                    $('.ui-modal[data-name="cashback-spend"]').trigger('show');
                    $('.js-bonus-spend-restriction').text(response.cashbackAvailable);
                    $('.js-order-bonus-spend-amount').val(response.cashbackAvailable)
                    $('.page-order-checkout__value--total').find('b').text($('.page-order-checkout__value--base b').text());
                    $('.page-order-checkout__cashback--current').find('b').text(response.cashbackAmount);
                    cashbackValue.attr('data-max',response.cashbackAvailable)
                }
                //$('.ui-modal[data-name="cashback-spend"]').trigger('hide');

            }, 200);
        } else {
            $('.js-form-order').find('button[type=submit]').attr('disabled',true);
            const response = cashbackOrderCancel();
            $('.page-order-checkout__cashback--current').find('input[name=bonuses_pay_amount]').val(0);
            $('.page-order').trigger('calculate');
            updatePrices(false,true).then(response => {
                cashbackValue.prop('checked', false);
                icon.removeClass('loading');
                cashbackRemove.hide();
            }).catch(()=>{
                icon.removeClass('loading');
            }).finally(()=>{
                $('.js-form-order').find('button[type=submit]').attr('disabled',false);
            })
        }
    });
    cashbackValue.on('input', function () {
        const max = parseInt($(this).data('max'), 10);
        let value = $(this).val();

        // Удаление отрицательных знаков
        value = value.replace(/-/g, '');

        // Преобразование значения в целое число
        const intValue = parseInt(value, 10);

        // Ограничение значения
        if (intValue > max) {
            $(this).val(max);
        } else if (intValue < 0) {
            $(this).val(0);
        } else {
            $(this).val(value);
        }

        // Удаление начальных нулей
        if ($(this).val().match(/^0/)) {
            $(this).val('');
            return false;
        }
    });

    form.on('submit',function (e) {
        e.preventDefault();
        $('.js-form-order').find('button[type=submit]').attr('disabled',true);
        let form = $(this).serializeObject()
        cashbackOrderSave(form).then(response => {
            if (response.isSuccess){
                icon.removeClass('loading');
                updatePrices(true,true).then(response => {
                    icon.removeClass('loading');
                    $('.page-order-checkout__cashback--current').find('input[name=bonuses_pay_amount]').val(form['order-bonus']);
                    $('.page-order').trigger('calculate');
                    cashbackRemove.find('b').text(form['order-bonus']);
                    cashbackRemove.show();
                }).catch(()=>{
                    cashbackValue.prop('checked', false);
                    icon.removeClass('loading');
                }).finally(()=>{
                    $('.js-form-order').find('button[type=submit]').attr('disabled',false);
                });
                $('.ui-modal[data-name="cashback-spend"]').trigger('hide');
            }
        })
    })
});
